export const featuredPortfolio = [
    {
      id: 1,
      title: "ASL Web App",
      img:
        "assets/signulationweb.png",
    },
    {
      id: 2,
      title: "AI Deep Learning Model",
      img:
        "assets/signs.png",
    },
    {
      id: 3,
      title: "E-commerce Web App",
      img:
        "assets/ecommerce.png",
    },
    {
      id: 4,
      title: "Shopify Store",
      img:
        "assets/shopify.png",
    },
    {
      id: 5,
      title: "Portfolio Design",
      img:
        "assets/portfolio.png",
    },
    {
      id: 6,
      title: "Wordpress Landing Page",
      img:
        "assets/wordpresslandingpage.png",
    },
  ];
  
  export const webPortfolio = [
    {
      id: 1,
      title: "Web UMS App",
      img: "assets/ums.png",
    },
    {
      id: 2,
      title: "E-commerce Web App",
      img:
        "assets/ecommerce.png",
    },
    {
      id: 3,
      title: "ASL Web App",
      img:
        "assets/signulationweb.png",
    },
  ];
  
  export const mobilePortfolio = [
    {
      id: 1,
      title: "Face Mask Detector",
      img:
        "assets/facemaskdetector.png",
    },
    {
      id: 2,
      title: "Sign Language Detector",
      img:
        "assets/signulation.png",
    },
    
  ];
  
  export const designPortfolio = [
    {
      id: 1,
      title: "Shopify Store Design",
      img:
        "assets/shopifydes.png",
    },
    {
      id: 2,
      title: "Portfolio Design",
      img:
        "assets/portfolio.png",
    },
    {
      id: 3,
      title: "Logo Design",
      img:
        "assets/logos.png",
    },
  ];
  
